/**
 * Party characteristics Phone Numbers section
 */
import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PhonesState = {
  phones: [],
  savePhonesTriggered: false,
}

export const PhonesActions = {
  fetchPhones: async ({ commit }, req) => {
    return axiosRequest.
      get(`/parties/${req.partyId}/phones`).
      then(({ data }) => {
        commit('setPhones', data.phones)
      }).
      catch(handleError)
  },
  createPhone: async ({ commit }, req) => {
    return axiosRequest.
      post(`/parties/${req.party_id}/phones`, { phone: req }).
      then(({ data }) => {
        commit('setPhones', data.phones)
      }).
      catch(handleError)
  },
  savePhone: async ({ commit }, req) => {
    return axiosRequest.
      patch(`/parties/${req.party_id}/phones/${req.id}`, { phone: req }).
      then(({ data }) => {
        commit('setPhones', data.phones)
      }).
      catch(handleError)
  },
}

export const PhonesMutations = {
  setPhones: (state, payload) => { state.phones = payload },
  setPhone: (state, payload) => { if (payload.index !== -1) Vue.set(state.phones, payload.index, payload.data) },
  setPhonesSaveTriggered: (state, payload) => {
    state.savePhonesTriggered = payload
  },
}

export const PhonesGetters = {
  getPhones: state => state.phones,
  getSavePhonesTriggered: state => state.savePhonesTriggered,
}
